import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { NavLink, RouteComponentProps } from 'react-router-dom';
import LiveAnimatedDot from 'shared/components/liveAnimatedDot';
import { AppTheme, APP_URL, SectionNavigation } from 'shared/constants/common';
import useResolvedColorScheme from 'shared/hooks/useResolvedColorScheme';
import useScrollDirection from 'shared/hooks/useScrollDirection';
import { State } from 'shared/interface';
import { elementVisibility, navLinks } from 'shared/util/utility';
import { useSpecialCategoryNameFeatureFlag } from '../../featureFlags';

interface Props extends RouteComponentProps {
	handleNavTab: (navType: SectionNavigation) => void;
	ref?: HTMLDivElement | null;
}

const BottomPanel: React.FC<Props> = (props: Props) => {
	const divRef = useRef<HTMLHeadingElement>(null);
	const { resolvedColorScheme } = useResolvedColorScheme();

	const specialCategoryNameFeatureFlag = useSpecialCategoryNameFeatureFlag();
	const inGameCouponCount = useSelector<State, number>((state) => state.inGameCouponCount.inGameCouponCount);

	const handleScrollToTop = () => {
		setTimeout(() => window.scrollTo({ top: 0, behavior: 'smooth' }), 50);
	};

	const { scrollDir, scrolledToBottom } = useScrollDirection(0);
	const className = `${elementVisibility(scrolledToBottom, scrollDir, 'bottom__panel')} bottom__panel width--full`;

	const isLiveChatVisible = useSelector<State, any>((state) => state.layout.isLiveChatVisible);

	useEffect(() => {
		const chatWidget = document.getElementById('chat-widget-container');
		chatWidget && chatWidget.style.setProperty('transition', '.4s all ease', 'important');
		chatWidget?.classList.add('chat-widget-container--visible');

		if (isLiveChatVisible?.isLiveChatVisible === 'maximized') {
			chatWidget?.classList.add('activated');
		} else {
			chatWidget?.classList.remove('activated');
		}

		if (isLiveChatVisible?.isLiveChatVisible === 'maximized') {
			chatWidget?.style.setProperty('inset', '0', 'important');
		} else if (scrollDir === 'up') {
			chatWidget?.classList.add('chat-widget-container--visible');
			chatWidget?.classList.remove('chat-widget-container--hidden');
		} else if ((scrolledToBottom && scrollDir === 'down') === true) {
			chatWidget?.classList.remove('chat-widget-container--hidden');
			chatWidget?.classList.add('chat-widget-container--visible');
		} else if (scrollDir === 'down') {
			chatWidget?.classList.remove('chat-widget-container--visible');
			chatWidget?.classList.add('chat-widget-container--hidden');
		}
	}, [isLiveChatVisible, scrollDir, scrolledToBottom]);

	return (
		<div ref={divRef} className={className}>
			<ul className="bottom__panel__list">
				{navLinks(resolvedColorScheme === AppTheme.DARK, specialCategoryNameFeatureFlag.value ?? 'Specjalne').map((navLink) => (
					<li
						className={`${
							props.location.pathname.includes(navLink.link)
								? 'bottom__panel__list__item bottom__panel__list__item--active'
								: 'bottom__panel__list__item'
						} `}
						key={navLink.name}
					>
						<NavLink to={navLink.link} onClick={handleScrollToTop}>
							<div
								className={`bottom__panel__btn flex flex--column align__items--center justify__content--end width--fit-content m--0-auto position--relative`}
							>
								{navLink.icon}
								<p className="letter-spacing--3 font-size--10 line-height--14 no--margin">{navLink.name}</p>

								{navLink.link === APP_URL.coupon && inGameCouponCount > 0 && (
									<p
										className={`count ${
											inGameCouponCount > 99 ? 'p--2' : ''
										} position--absolute flex justify__content--center align__items--center b-radius--circle no--margin font-size--3 text--white font--bold`}
									>
										{inGameCouponCount}
									</p>
								)}
								{navLink.link === APP_URL.live && <LiveAnimatedDot className="liveAnimatedDot--bottomPanel" />}
							</div>
						</NavLink>
					</li>
				))}
			</ul>
		</div>
	);
};

export default BottomPanel;
